import { useState, useEffect } from 'react';
import { Card, Row, Col, Form, Input, Select, Button, Steps, Tag, Spin, message, Timeline, Progress } from 'antd';
import { RobotOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { agentCrewAPI } from '../../api/agentCrew';

const AgentCrewPage = () => {
  const [agents, setAgents] = useState([]);
  const [task, setTask] = useState(null);
  const [form] = Form.useForm();

  useEffect(() => {
    agentCrewAPI.getAgents().then(res => setAgents(res.data || []));
  }, []);

  const handleCreateTask = async (values) => {
    const res = await agentCrewAPI.createTask(values);
    setTask(res.data);
    message.success('任务已启动，4个Agent正在协作...');
  };

  return (
    <div>
      <h2>🤖 多Agent内容流水线 - 4个AI协作，1-2分钟出2000字长文</h2>
      <p style={{ color: '#666', marginBottom: 24 }}>
        研究员🔍 → 撰稿人✍️ → 编辑📝 → 审核员✅，全流程自动化，每步可追溯
      </p>

      <Row gutter={16} style={{ marginBottom: 24 }}>
        {agents.map(a => (
          <Col span={6} key={a.role}>
            <Card size="small" hoverable>
              <div style={{ fontSize: 32 }}>{a.icon}</div>
              <h4>{a.name}</h4>
              <p style={{ color: '#999', fontSize: 12 }}>{a.desc}</p>
            </Card>
          </Col>
        ))}
      </Row>

      <Row gutter={24}>
        <Col span={10}>
          <Card title="创建协作任务">
            <Form form={form} layout="vertical" initialValues={{ targetType: 'blog', language: 'zh' }} onFinish={handleCreateTask}>
              <Form.Item name="topic" label="创作主题" rules={[{ required: true }]}>
                <Input placeholder="例如：2026年跨境电商独立站运营完全指南" />
              </Form.Item>
              <Space>
                <Form.Item name="targetType" label="输出类型">
                  <Select options={[
                    { value: 'blog', label: '博客长文' },
                    { value: 'video_script', label: '视频脚本' },
                    { value: 'social_post', label: '社媒帖子' },
                    { value: 'email', label: '邮件营销' },
                  ]} style={{ width: 140 }} />
                </Form.Item>
                <Form.Item name="language" label="语言">
                  <Select options={[
                    { value: 'zh', label: '中文' },
                    { value: 'en', label: '英语' },
                    { value: 'ja', label: '日语' },
                  ]} style={{ width: 100 }} />
                </Form.Item>
              </Space>
              <Button type="primary" block htmlType="submit" icon={<RobotOutlined />}>启动多Agent协作</Button>
            </Form>
          </Card>
        </Col>
        <Col span={14}>
          <Card title="协作进度" extra={task && <Tag color="blue">{task.status}</Tag>}>
            {task ? (
              <div>
                <h4>任务：{task.topic}</h4>
                <Progress percent={task.progress} status="active" />
                <Timeline mode="left" style={{ marginTop: 24 }}>
                  {task.agents?.map((a, i) => (
                    <Timeline.Item key={i} color={a.status === 'running' ? 'blue' : a.status === 'completed' ? 'green' : 'gray'}
                      dot={a.status === 'running' ? <Spin size="small" /> : null}>
                      <strong>{a.name}</strong>: {a.task}
                    </Timeline.Item>
                  ))}
                </Timeline>
                {task.draft && (
                  <Card size="small" title="生成结果" style={{ marginTop: 16 }}>
                    <h3>{task.draft.title}</h3>
                    <p>字数：{task.draft.wordCount} | 阅读时间：{task.draft.readTime}</p>
                  </Card>
                )}
              </div>
            ) : (
              <div style={{ textAlign: 'center', padding: 40, color: '#999' }}>
                <RobotOutlined style={{ fontSize: 48 }} />
                <p>创建一个任务来启动多Agent协作</p>
              </div>
            )}
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default AgentCrewPage;
